import { Unstable_Grid2 as Grid } from '@mui/material';

import { ToggleButtonGroupField } from '@occc-app/design-system';
import { OfferFilter } from '@occc/graphql';
import { OfferSelect } from '@occc-app/routes/CampaignComponents/components/OfferSelect/OfferSelect';

import { offerActivationItems } from './constants';

type OfferActivationFormArrayItemProps = {
  fieldArrayName: string;
  makeOffersFilter: (search: string) => OfferFilter;
};

export const OfferActivationFormArrayItem = ({
  fieldArrayName,
  makeOffersFilter,
}: OfferActivationFormArrayItemProps) => {
  return (
    <Grid container spacing={3} mb={2}>
      <Grid xs={12} sm={6} md={3} display='flex' justifyContent='center'>
        <ToggleButtonGroupField
          name={`${fieldArrayName}.operator`}
          buttons={offerActivationItems}
        />
      </Grid>
      <Grid xs={12} sm={6} md={3}>
        <OfferSelect
          makeOffersFilter={makeOffersFilter}
          name={`${fieldArrayName}.targetOffer`}
          label='Offer'
        />
      </Grid>
    </Grid>
  );
};
